import React, { useEffect, useState } from 'react';
import ApiClient from '../../methods/api/apiClient';
import './style.scss';
import loader from '../../methods/loader';
import Html from './html';
import { useNavigate } from 'react-router-dom';
import environment from '../../environment';
import axios from 'axios';
import shared from './shared';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import SubscriptionBlockModal from './SubscriptionBlockModal';
import ThankYouRequestModal from '../RegistrationList/ThankYouRequestModal';

const Members = () => {
    const user = useSelector((state) => state.user);
    const searchState = {data:''}
    const [filters, setFilter] = useState({ page: 1, count: 50, search: '', catType: '', sortBy: 'fullName asc' })
    const [data, setData] = useState([])
    const [total, setTotal] = useState(0)
    const [loaging, setLoader] = useState(true)
    const [roles, setRoles] = useState([])
    const [invitations, setInvitations] = useState([])
    const [subscriptionBlocked, setSubscriptionBlocked] = useState(false)
    const [subscriptionStatus, setSubscriptionStatus] = useState(null)
    const [tyModalRow, setTyModalRow] = useState(null)
    const [tySubmitting, setTySubmitting] = useState(false)
    const history = useNavigate()

    // Fetch roles from skillroles API
    const getRoles = () => {
        ApiClient.get('api/skillRole/list', { status: 'active' }).then(res => {
            if (res.success && res.data) {
                // Map to format expected by SelectDropdown: {id, name}
                const cmLabel = user?.connectMeetLabel || 'ConnectMeet';
                const tyLabel = user?.testimonialLabel || 'Thank Yous';
                const rolesList = res.data.map(role => ({
                    id: role._id,
                    name: (role.name || '').replace(/ConnectMeet/gi, cmLabel).replace(/Thank You/gi, tyLabel)
                }))
                setRoles(rolesList)
            }
        })
    }

    const getInvitations = () => {
        const groupId = user?.groupId?._id || user?.groupId;
        if (!groupId) return;
        ApiClient.get(shared.invitationsListApi, { groupId }).then(res => {
            if (res.success && res.data) {
                setInvitations(res.data)
            }
        })
    }

    const resendInvitation = (id) => {
        Swal.fire({
            title: "Resend Invitation?",
            text: "This will generate a new link valid for 7 days.",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, resend"
        }).then((result) => {
            if (result.isConfirmed) {
                loader(true)
                ApiClient.put(shared.resendInvitationApi, { id }).then(res => {
                    if (res.success) {
                        getInvitations()
                    }
                    loader(false)
                })
            }
        })
    }


    const resendAllInvitations = () => {
        const expired = invitations.filter(inv =>
            inv.status === 'failed' || inv.status === 'expired' || (inv.expiresAt && new Date(inv.expiresAt) < new Date())
        );
        if (!expired.length) return;
        Swal.fire({
            title: `Resend ${expired.length} Invitation${expired.length > 1 ? 's' : ''}?`,
            text: "This will generate new links valid for 7 days.",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, resend all"
        }).then(async (result) => {
            if (result.isConfirmed) {
                loader(true)
                for (const inv of expired) {
                    await ApiClient.put(shared.resendInvitationApi, { id: inv._id })
                }
                getInvitations()
                loader(false)
            }
        })
    }

    const revokeInvitation = (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "This will revoke the invitation immediately.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, revoke it"
        }).then((result) => {
            if (result.isConfirmed) {
                loader(true)
                ApiClient.put(shared.revokeInvitationApi, { id }).then(res => {
                    if (res.success) {
                        getInvitations()
                    }
                    loader(false)
                })
            }
        })
    }

    const checkGroupSubscription = (callback) => {
        const groupId = user?.lastUsedGroupId?._id || user?.lastUsedGroupId || user?.groupId?._id || user?.groupId;
        if (!groupId) { if (callback) callback(false); return; }
        const roleId = user?.customerRole?._id || user?.customerRole;
        const isGL = environment.groupLeaderRoleIds?.includes(roleId);
        if (!isGL) { if (callback) callback(false); return; }
        ApiClient.get('api/group/detail', { id: groupId }).then(res => {
            if (res.success && res.data) {
                const sub = res.data.subscription || {};
                // Comp/test groups: no cap, no billing required
                if (sub.unlimitedMembers) {
                    const status = { unlimitedMembers: true, hasSubscription: true, isExpired: false, isOverLimit: false, isAtLimit: false, blocked: false };
                    setSubscriptionStatus(status);
                    if (callback) callback(false, status);
                    return;
                }
                const maxMembers = sub.maxMembers || 0;
                const endDate = sub.endDate || null;
                const hasSubscription = maxMembers > 0 && endDate;
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                const isExpired = endDate ? new Date(endDate) <= today : false;
                ApiClient.get('api/members/list', { groupId, count: 1, page: 1 }).then(memRes => {
                    const memberCount = memRes?.total || 0;
                    const isOverLimit = maxMembers > 0 && memberCount > maxMembers;
                    const isAtLimit = maxMembers > 0 && memberCount >= maxMembers;
                    const blocked = !hasSubscription || isExpired || isAtLimit;
                    const status = { maxMembers, memberCount, endDate, hasSubscription, isExpired, isOverLimit, isAtLimit, blocked };
                    setSubscriptionStatus(status);
                    if (callback) callback(blocked, status);
                });
            } else {
                setSubscriptionStatus({ hasSubscription: false });
                if (callback) callback(true);
            }
        });
    }

    const handleAddMember = () => {
        checkGroupSubscription((blocked) => {
            if (blocked) {
                setSubscriptionBlocked(true);
            } else {
                history(`/${shared.url}/add`);
            }
        });
    }

    const deleteInvitation = (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "This will permanently delete this invitation.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#6c757d",
            confirmButtonText: "Yes, delete it"
        }).then((result) => {
            if (result.isConfirmed) {
                loader(true)
                ApiClient.put(shared.deleteInvitationApi, { id }).then(res => {
                    if (res.success) {
                        getInvitations()
                    }
                    loader(false)
                })
            }
        })
    }

    useEffect(() => {
        if (user && user.loggedIn) {
            setFilter({ ...filters, search: searchState.data })
            getData({ search: searchState.data, page: 1 })
            getRoles()
            getInvitations()
        }
    }, [])


    const sortClass = (key) => {
        let cls = 'fa-sort'
        if (filters.key == key && filters.sorder == 'asc') cls = 'fa-sort-up'
        else if (filters.key == key && filters.sorder == 'desc') cls = 'fa-sort-down'
        return 'fa ' + cls
    }


    const sorting = (key) => {
        let sorder = 'asc'
        if (filters.key == key) {
            if (filters.sorder == 'asc') {
                sorder = 'desc'
            } else {
                sorder = 'asc'
            }
        }

        let sortBy = `${key} ${sorder}`;
        setFilter({ ...filters, sortBy, key, sorder })
        getData({ sortBy, key, sorder })
    }

    const getData = (p = {}) => {
        setLoader(true)
        let filter = { ...filters, ...p ,
            // addedBy:user._id,
            groupId:user?.groupId?._id}
        ApiClient.get(shared.listApi, filter).then(res => {
            if (res.success) {
                setData(res?.data?.map(itm => {
                    itm.id = itm._id
                    return itm
                }))
                setTotal(res.total)
            }
            setLoader(false)
        })
    }

    const filter = (p={}) => {
        let f={
            page:1,
            ...p
        }
        setFilter({ ...filters, ...f})
        getData({ ...f})
    }
    const clear = () => {
        setFilter({ ...filters, search: '',status:'', page: 1 })
        getData({ search: '', status:'',page: 1 })
    }

    const deleteItem = (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to remove this member from the group?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes"
          }).then((result) => {
            if (result.isConfirmed) {
                loader(true)
                const groupId = user.lastUsedGroupId?._id || user.lastUsedGroupId || user.groupId?._id || user.groupId;
                ApiClient.delete(shared.deleteApi, { id: id, groupId: groupId }).then(res => {
                            if (res.success) {
                                clear()
                            }
                            loader(false)
                        })
            //   Swal.fire({
            //     icon: "success"
            //   });
            }
          });
    }

    const pageChange = (e) => {
        setFilter({ ...filters, page: e })
        getData({ page: e })
    }
    const count = (e) => {
        setFilter({ ...filters, count:e })
        getData({ ...filters ,count: e })
        }
    const changestatus = (e) => {
        setFilter({ ...filters, status: e, page: 1 })
        getData({ status: e, page: 1 })
    }


    const statusChange = (itm) => {
        let status = 'active'
        if (itm.status == 'active') status = 'deactive'

        if (window.confirm(`Do you want to ${status == 'active' ? 'Activate' : 'Deactivate'} this`)) {
            loader(true)
            ApiClient.put(shared.statusApi, { id: itm.id, status }).then(res => {
                if (res.success) {
                    getData()
                }
                loader(false)
            })
        }
    }

    const edit = (id) => {
        history(`/${shared.url}/edit/${id}`)
    }

    const view = (id) => {
        let url=`/${shared.url}/detail/${id}`
        history(url)
    }

    

    const exportfun = async () => {
        const token = await localStorage.getItem("token");
        const req = await axios({
            method: "get",
            url: `${environment.api}api/export/excel`,
            responseType: "blob",
            body: { token: token }
        });
        var blob = new Blob([req.data], {
            type: req.headers["content-type"],
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${shared.title}.xlsx`;
        link.click();
    }

    const isAllow = (key = '') => {
        let permissions = user.customerRole?.permissions
        let value = permissions?.[key]
        return value
    }

    // cw: Registration List — quick actions from the Members page. connectMeet/testimonial
    // labels are the group's custom labels (never hard-coded).
    const connectMeetLabel = user?.connectMeetLabel || 'ConnectMeet';
    const testimonialLabel = user?.testimonialLabel || 'Thank You';

    const activeGroupId = () =>
        user?.lastUsedGroupId?._id || user?.lastUsedGroupId || user?.groupId?._id || user?.groupId;

    // Queue a CM with this person for the NEXT event they appear in (FIFO deferred queue).
    const requestFutureCm = (row) => {
        const groupId = activeGroupId();
        const targetUserId = row?.odlUserId || row?.id || row?._id;
        if (!groupId || !targetUserId) { toast.error('Missing group or member'); return; }
        loader(true);
        ApiClient.post('api/deferred-cm/add', { targetUserId, targetEmail: row?.email, groupId }).then(res => {
            loader(false);
            if (res?.success) {
                toast.success(res.message || `${connectMeetLabel} queued for the next event`);
            } else {
                toast.error(res?.message || `Failed to queue ${connectMeetLabel}`);
            }
        });
    };

    // Open the Thank You request popup for this person (recipient pre-filled). On submit it
    // FIFO-defers to the next event the giver attends, carrying the type + note entered here.
    const requestFutureTy = (row) => {
        const groupId = activeGroupId();
        const targetUserId = row?.odlUserId || row?.id || row?._id;
        if (!groupId || !targetUserId) { toast.error('Missing group or member'); return; }
        if (targetUserId === user?._id) { toast.error(`You can't ${testimonialLabel.toLowerCase()} yourself`); return; }
        setTyModalRow(row);
    };

    const submitFutureTy = (thankYouType, note) => {
        const row = tyModalRow;
        if (!row) return;
        const groupId = activeGroupId();
        const targetUserId = row?.odlUserId || row?.id || row?._id;
        setTySubmitting(true);
        ApiClient.post('api/deferred-cm/add', {
            targetUserId, targetEmail: row?.email, groupId, type: 'ty', thankYouType, note,
        }).then(res => {
            setTySubmitting(false);
            if (res?.success) {
                toast.success(res.message || `${testimonialLabel} queued for the next event`);
                setTyModalRow(null);
            } else {
                toast.error(res?.message || `Failed to queue ${testimonialLabel}`);
            }
        });
    };

    const roleUpdate=(row, customerRoleId)=>{
        if(!customerRoleId) return
        
        let payload={
            id: row.odlUserId || row.id,  // Use odlUserId (user's _id) for updating
            customerRole: customerRoleId,
            groupId: row?.groupId,
        }
        
        loader(true)
        ApiClient.put('api/user/update-role', payload).then(res=>{
            loader(false)
            if(res.success){
                getData()
            }
        })
    }

    return <>
    {subscriptionBlocked && (
        <SubscriptionBlockModal
            status={subscriptionStatus}
            onClose={() => {
                setSubscriptionBlocked(false);
            }}
        />
    )}
    <ThankYouRequestModal
        open={!!tyModalRow}
        recipientName={tyModalRow?.fullName || tyModalRow?.name || tyModalRow?.email || ''}
        receivedById={tyModalRow?.odlUserId || tyModalRow?.id || tyModalRow?._id}
        testimonialLabel={testimonialLabel}
        submitting={tySubmitting}
        onClose={() => setTyModalRow(null)}
        onSubmit={submitFutureTy}
    />
    <Html
        edit={edit}
        view={view}
        clear={clear}
        roleUpdate={roleUpdate}
        roles={roles}
        sortClass={sortClass}
        sorting={sorting}
        isAllow={isAllow}
        pageChange={pageChange}
        count={count}
        deleteItem={deleteItem}
        filters={filters}
        filter={filter}
        setFilter={setFilter}
        loaging={loaging}
        data={data}
        total={total}
        statusChange={statusChange}
        changestatus={changestatus}
        exportfun={exportfun}
        invitations={invitations}
        revokeInvitation={revokeInvitation}
        resendInvitation={resendInvitation}
        resendAllInvitations={resendAllInvitations}
        handleAddMember={handleAddMember}
        deleteInvitation={deleteInvitation}
        connectMeetLabel={connectMeetLabel}
        testimonialLabel={testimonialLabel}
        requestFutureCm={requestFutureCm}
        requestFutureTy={requestFutureTy}
    />
    </>;
};

export default Members;
